var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEnterpriseColored1 = function SvgEnterpriseColored1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M2.857 25.143h22.286M18.434 6.733h-8.72v18.41h8.72zM23.019 15.453h-3.876v9.69h3.876zM9.304 15.453H5.43v9.69h3.875zM15.714 3.714h-3.428v2.572h3.428zM14 3.714V2M14.857 10.571h-1.714M14.857 14h-1.714M14.857 17.429h-1.714"
  })));
};
export default SvgEnterpriseColored1;